<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="margin-top:20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="DK_NAME" label="名称"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="addProduct(scope.row)">匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="匹配档口" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm">
            <el-form-item label="档口别名：" :label-width="formLabelWidth">
              <el-input v-model="addForm.DK_NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { matchDKFun, matchDKGroupFun } from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      // loading: false,
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      searchForm: {},
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
    };
  },
  methods: {
    handleCurrentChange() {
      this.queryData();
    },
    // ------------------------------------------进入页面拉取数据
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      matchDKFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    addProduct(row) {
      this.addFormVisible = true;
      this.addForm = row;
    },
    // -----------------------------------------匹配档口成功
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            GROUP_ID: sessionStorage.getItem('kindId'),
            DK_ID: Number(this.addForm.DK_ID),
          };
          matchDKGroupFun(params).then((result) => {
            this.$message.show({ text: '匹配成功', type: 'success' });
            this.queryData();
            this.addFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/matchDK.vue